export default __webpack_public_path__ + "static/media/9.40776333.jpeg";